import { Link } from "react-router-dom";

export function PageHeader({ code, title, sub }) {
  return (
    <section className="border-b border-border" data-testid="page-header">
      <div className="mx-auto max-w-7xl px-5 py-16 md:py-24">
        <p className="mono-label text-primary" data-testid="page-code">{code}</p>
        <h1 className="mt-4 font-display text-4xl font-700 uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl font-body text-base text-muted-foreground md:text-lg">{sub}</p>
      </div>
    </section>
  );
}

export function CtaButton({ to, href, children, testid, variant = "primary" }) {
  const base =
    "mono-label inline-flex items-center gap-3 px-7 py-4 transition-all duration-200 clip-notch";
  const styles =
    variant === "primary"
      ? "bg-primary text-primary-foreground hover:bg-foreground hover:text-background"
      : "border border-border text-foreground hover:border-primary hover:text-primary";
  if (href) {
    return (
      <a href={href} data-testid={testid} className={`${base} ${styles}`}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testid} className={`${base} ${styles}`}>
      {children}
    </Link>
  );
}
